export const ADD_GLOBAL_SUCCESS_MESSAGE = "ADD_GLOBAL_SUCCESS_MESSAGE";
export const COOKIES_IS_UPDATED = "COOKIES_IS_UPDATED";
